import {Nullable} from '../../app/TypeHelpers'

export class EquipmentSimple {
    constructor(
        readonly id: number,
        readonly condominiumCd: string,
        readonly name: string,
        readonly reservationCountDaily: Nullable<number>,
        readonly reservationCountMonthly: Nullable<number>,
        readonly lotteryEntryCountMonthly : Nullable<number>,
        ) {
    }

    static from(json: any): EquipmentSimple {
        return new EquipmentSimple(
            Number(json.id),
            json.condominiumCd,
            json.name,
            json.reservationCountDaily,
            json.reservationCountMonthly,
            json.lotteryEntryCountMonthly,
        )
    }
}
